import { useGetParentViewUniversitiesApplyingTo } from '@actions';
import SkeletonBox from '@components/V4/SkeletonBox';
import ApplicationStatusPill from '@modules/Account/Profile/components/AccountProfile/ProfileMain/GoalsTab/UniversitiesSection/UniversitiesSectionCard/ApplicationStatusPill';
import { GoalStatusTypes } from '@shared/enums';
import { useTranslation } from 'apps/agora/src/TranslationContext';
import moment from 'moment';
import { useParams } from 'react-router';

const ParentPageUniversitiesApplyingTo = () => {
  const { studentId } = useParams<{ studentId: string }>();
  const token = localStorage.getItem('parentToken');
  const { data, isLoading } = useGetParentViewUniversitiesApplyingTo({
    userId: studentId,
    token: token ?? '',
  });
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <section className="flex flex-col gap-3 p-6 rounded-xl bg-surfaceObject">
        <h2 className="font-raleway font-bold">{t('parent_universities_applying_title')}</h2>
        <div className="grid gap-3 grid-cols-[repeat(auto-fill,minmax(320px,1fr))]">
          {[...Array(3)].map((_, idx) => (
            <SkeletonBox key={idx} className="w-full h-[150px]" />
          ))}
        </div>
      </section>
    );
  }

  if (!data?.goals?.length) return null;

  return (
    <section className="flex flex-col gap-1 p-6 rounded-xl bg-surfaceObject">
      <h2 className="font-raleway font-bold">{t('parent_universities_applying_title')}</h2>
      <p className="text-customGrey text-sm mb-4">{t('parent_universities_applying_subtitle')}</p>
      <div className="grid gap-3 grid-cols-[repeat(auto-fill,minmax(320px,1fr))]">
        {data.goals.map((goal) => (
          <div
            key={goal._id}
            className="flex flex-col gap-2 p-4 rounded-lg bg-surfaceComplementary border border-white/5"
          >
            <div className="flex items-start gap-3">
              <span className="text-lg font-bold text-customGrey min-w-[28px] leading-tight">
                #{goal.order}
              </span>
              <h3 className="font-raleway text-base font-semibold flex-1 leading-tight">
                {goal.name}
              </h3>
            </div>

            <ApplicationStatusPill status={goal.status as GoalStatusTypes} useTranslations={true} />

            {!!goal.majors?.length && (
              <p className="text-sm text-white">{goal.majors.join(', ')}</p>
            )}

            <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-customGrey mt-1">
              <span>
                {t('parent_application_deadline')}:{' '}
                <span className="text-white font-medium">
                  {moment(goal.deadline).format('DD MMM YYYY')}
                </span>
              </span>
              {goal.resultsDate && (
                <span>
                  {t('parent_results_date')}:{' '}
                  <span className="text-white font-medium">
                    {moment(goal.resultsDate).format('DD MMM YYYY')}
                  </span>
                </span>
              )}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ParentPageUniversitiesApplyingTo;
